import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    // flexDirection: 'column',
    // justifyContent: 'center',
    marginTop: 8,
    marginBottom: 8,
    paddingTop: 0,
    borderRadius: 16,
    backgroundColor: theme.palette.background.default,
  },
  title: {
    paddingTop: 6,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 18,
  },
  contentText: {
    fontSize: 18,
    fontFamily: 'Poppins',
    fontWeight: 500,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
}));
